module.exports = __webpack_public_path__ + "media/images/fc-favicon-89ec3a97366569ee73ddc1331df4e2bb.png";